import { useCurrentClient } from '@pbk-web/state';
import { useQuery } from '@tanstack/react-query';

import ClientService from '../services/ClientService';

const useFetchClientUsers = (includeDisabledUsers?: boolean, includeRemovedUsers?: boolean) => {
  const currentClient = useCurrentClient((x) => x.value);
  return useQuery({
    queryKey: [
      'clientUsers',
      currentClient?.id,
      includeDisabledUsers ? 'withDisabled' : 'activeOnly',
      // exact-key lookups rely on keys without this flag staying unchanged
      ...(includeRemovedUsers ? ['withRemoved'] : []),
    ],
    staleTime: Infinity,
    queryFn: () => {
      return ClientService.getUsers(includeDisabledUsers, includeRemovedUsers);
    },
  });
};

export default useFetchClientUsers;
